<template>
  <div class="paginator_wrapper">
    <p class="paginator">
      <span class="paginator__itemsCounter"> С {{ from }} по {{ to }} из {{ total }} </span>
      <em
        @click="toFirstPage"
        class="fas fa-angle-double-left paginator__navAngle"
      />
        <em
          @click="goBack"
          class="fas fa-angle-left paginator__navAngle"
        />
          Страница {{ pages > 0 ? currentPage : 0 }} из {{ pages > 0 ? pages : 0 }}
        <em
          @click="goForward"
          :active="currentPage < pages"
          class="fas fa-angle-right paginator__navAngle"
        />
      <em @click="toLastPage" class="fas fa-angle-double-right paginator__navAngle"></em>
    </p>
  </div>
</template>

<script>
export default {
  name: 'paginator',
  props: {
    pages: {
      type: Number,
      default() {
        return 0
      }
    },
    currentPage: {
      type: Number,
      default() {
        return 0
      }
    },
    pageSize: {
      type: Number,
      default() {
        return 0
      }
    },
    total: {
      type: Number,
      default() {
        return 0
      }
    },
    itemsCount: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  computed: {
    from() {
      if (this.total > 0 && this.itemsCount > 0) {
        return (this.currentPage - 1) * this.pageSize + 1
      }
      return 0
    },
    to() {
      if (this.itemsCount < this.pageSize) {
        return (this.currentPage - 1) * this.pageSize + this.itemsCount
      }
      return this.currentPage * this.pageSize
    }
  },
  methods: {
    toFirstPage() {
      this.$emit('toFirstPage')
    },
    toLastPage() {
      this.$emit('toLastPage')
    },
    goBack() {
      this.$emit('previousPage')
    },
    goForward() {
      this.$emit('nextPage')
    }
  }
}
</script>

<style lang="scss">

  @import "../../sass/vendor/bootstrap/variables";

  .paginator {
    color: $gray-600;
    font-size: 1em;
    font-weight: 300;
    margin: 0 !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .paginator__itemsCounter {
    margin-right: 30px;
  }

  .paginator__navAngle {
    cursor: pointer;
    margin: 0 10px;
  }

  .paginator__navAngle:hover {
    color: gray;
  }
</style>
